import React, {Component} from 'react';
import '../css/Page.css';
import home from '../images/HOME.jpg';

class PageHome extends Component {

    render() {
        return (
                <div className="page">
                    <article>
                        <p>L&rsquo;Areamultiservice &egrave; un&rsquo;Agenzia di servizi specializzata per supportare le imprese che intendono operare nel mondo degli appalti pubblici.
                            <br/>La mission &egrave; aiutare le aziende a raggiungere obiettivi importanti, quali l'assegnazione di appalti e il conseguimento delle certificazioni specifiche.
                            <br/>L&rsquo;Areamultiservice si propone come riferimento per i propri clienti per i diversi servizi che pu&ograve; offrire nel campo della consulenza
                            degli Appalti Pubblici e ha lo scopo di facilitare lo svolgimento di tali attivit&agrave;; dal reperimento del bando, ai requisiti SOA, al fine di poter partecipare (avvalimento), alla preparazione della gara, nonch&eacute; alla consegna del plico stesso.
                            <br/>L&rsquo;Areamultiservice, mette a disposizione dei propri clienti un personale attento, qualificato e puntuale ed a completo servizio delle esigenze che verranno a manifestarsi garantendo loro servizi dedicati e ben concreti.
                        </p>
                        <h3>Chiedici un consulto gratuito.</h3>

                        <div>
                            <img className="homeImage" src={home} alt="areamultiservice"/>
                        </div>

                    </article>
                </div>
        );
    }
}

export default PageHome;


// WEBPACK FOOTER //
// ./src/page/js/PageHome.js